// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Global box-sizing and overflow prevention */
*,
*::before,
*::after {
  box-sizing: border-box;
}

html,
body {
  overflow-x: hidden;
  max-width: 100%;
}

body {
  margin: 0;
  padding: 0;
}

/* Prevent horizontal overflow on all containers */
.main-content,
.content,
.custom-footer,
.footer-content {
  max-width: 100%;
  overflow-x: hidden;
}

/* ── Compliance "Non-Compliant Resources" dialog — force near full-screen
   size regardless of how much/little data it contains ── */
saf-dialog.compliance-resource-dialog::part(overlay) {
  align-items: center;
  justify-content: center;
}
saf-dialog.compliance-resource-dialog::part(control) {
  width: 95vw !important;
  max-width: 95vw !important;
  height: 90vh !important;
  max-height: 90vh !important;
}
saf-dialog.compliance-resource-dialog::part(content) {
  height: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

/* Mobile */
@media (max-width: 767px) {
  .element {
    width: 100%;
    padding: 10px;
  }

  .App-content {
    max-width: 100%;
    padding: 0% 3%;
  }

  .Form {
    padding: 0 3%;
    border-style: groove;
  }

  .headers {
    max-height: 35rem;
    overflow: auto;
    padding: 10px;
    padding-top: 0px;
  }

  .dialog-header {
    max-height: 35rem;
    overflow: auto;
  }

  /* Asset Information Cards - Mobile */
  .asset-info-container {
    flex-direction: column !important;
    gap: 15px !important;
  }

  .asset-info-card {
    min-width: 100% !important;
    width: 100% !important;
  }
}

/* Tablet */
@media (min-width: 768px) and (max-width: 1023px) {
  .element {
    width: 50%;
    padding: 15px;
  }

  .App-content {
    max-width: 100%;
    padding: 0% 6%;
  }

  .Form {
    padding: 0 6%;
    border-style: groove;
  }

  .headers {
    max-height: 35rem;
    overflow: auto;
    padding-top: 0px;
  }

  .dialog-header {
    max-height: 35rem;
    overflow: auto;
  }

  /* Asset Information Cards - Tablet */
  .asset-info-container {
    flex-direction: column !important;
    gap: 20px !important;
  }

  .asset-info-card {
    min-width: 100% !important;
    width: 100% !important;
  }
}

/* Desktop */
@media (min-width: 1024px) {
  .element {
    width: 33.33%;
    padding: 20px;
  }

  .App-content {
    max-width: 100%;
    padding: 0% 6%;
  }

  .Form {
    padding: 0 6%;
    border-style: groove;
  }

  .headers {
    max-height: 35rem;
    overflow: auto;
    padding: 20px;
    padding-top: 0px;
  }

  .dialog-header {
    max-height: 35rem;
    overflow: auto;
  }

  /* Asset Information Cards - Desktop */
  .asset-info-container {
    flex-direction: row !important;
    gap: 20px !important;
  }

  .asset-info-card {
    flex: 1 1 !important;
    min-width: 300px !important;
  }

  /* Desktop table adjustments */
  .mytable th,
  .mytable td {
    padding: 12px 8px;
    max-width: 200px;
  }
}

.custom-header {
  margin-top: 25px;
  position: fixed;
  width: 100%;
  background-color: #fafafa;
  padding-left: 16px;
  z-index: 99;
  box-sizing: border-box;
}

.show-description {
  position: fixed;
  top: 95px;
  left: 50%;
  transform: translateX(-50%);
  width: 90vw;
  max-width: 700px;
  background: #f5f5f5;
  color: #222;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  border-radius: 8px;
  padding: 18px 22px;
  z-index: 999;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.08);
  font-size: 16px;
  font-weight: 400;
  word-break: break-word;
  white-space: normal;
  overflow: hidden;
}

.cloud-permit-header {
  max-width: calc(100% - 220px);
  display: flex;
  align-items: center;
  justify-content: space-between;
}
`, "",{"version":3,"sources":["webpack://./src/css/common.css"],"names":[],"mappings":"AAAA,8CAA8C;AAC9C;;;EAGE,sBAAsB;AACxB;;AAEA;;EAEE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,UAAU;AACZ;;AAEA,kDAAkD;AAClD;;;;EAIE,eAAe;EACf,kBAAkB;AACpB;;AAEA;2DAC2D;AAC3D;EACE,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,sBAAsB;EACtB,0BAA0B;EAC1B,uBAAuB;EACvB,2BAA2B;AAC7B;AACA;EACE,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA,WAAW;AACX;EACE;IACE,WAAW;IACX,aAAa;EACf;;EAEA;IACE,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,aAAa;IACb,oBAAoB;EACtB;;EAEA;IACE,iBAAiB;IACjB,cAAc;IACd,aAAa;IACb,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;IACjB,cAAc;EAChB;;EAEA,qCAAqC;EACrC;IACE,iCAAiC;IACjC,oBAAoB;EACtB;;EAEA;IACE,0BAA0B;IAC1B,sBAAsB;EACxB;AACF;;AAEA,WAAW;AACX;EACE;IACE,UAAU;IACV,aAAa;EACf;;EAEA;IACE,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,aAAa;IACb,oBAAoB;EACtB;;EAEA;IACE,iBAAiB;IACjB,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;IACjB,cAAc;EAChB;;EAEA,qCAAqC;EACrC;IACE,iCAAiC;IACjC,oBAAoB;EACtB;;EAEA;IACE,0BAA0B;IAC1B,sBAAsB;EACxB;AACF;;AAEA,YAAY;AACZ;EACE;IACE,aAAa;IACb,aAAa;EACf;;EAEA;IACE,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,aAAa;IACb,oBAAoB;EACtB;;EAEA;IACE,iBAAiB;IACjB,cAAc;IACd,aAAa;IACb,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;IACjB,cAAc;EAChB;;EAEA,sCAAsC;EACtC;IACE,8BAA8B;IAC9B,oBAAoB;EACtB;;EAEA;IACE,oBAAkB;IAClB,2BAA2B;EAC7B;;EAEA,8BAA8B;EAC9B;;IAEE,iBAAiB;IACjB,gBAAgB;EAClB;AACF;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,0CAA0C;EAC1C,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC","sourcesContent":["/* Global box-sizing and overflow prevention */\n*,\n*::before,\n*::after {\n  box-sizing: border-box;\n}\n\nhtml,\nbody {\n  overflow-x: hidden;\n  max-width: 100%;\n}\n\nbody {\n  margin: 0;\n  padding: 0;\n}\n\n/* Prevent horizontal overflow on all containers */\n.main-content,\n.content,\n.custom-footer,\n.footer-content {\n  max-width: 100%;\n  overflow-x: hidden;\n}\n\n/* ── Compliance \"Non-Compliant Resources\" dialog — force near full-screen\n   size regardless of how much/little data it contains ── */\nsaf-dialog.compliance-resource-dialog::part(overlay) {\n  align-items: center;\n  justify-content: center;\n}\nsaf-dialog.compliance-resource-dialog::part(control) {\n  width: 95vw !important;\n  max-width: 95vw !important;\n  height: 90vh !important;\n  max-height: 90vh !important;\n}\nsaf-dialog.compliance-resource-dialog::part(content) {\n  height: 100%;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n}\n\n/* Mobile */\n@media (max-width: 767px) {\n  .element {\n    width: 100%;\n    padding: 10px;\n  }\n\n  .App-content {\n    max-width: 100%;\n    padding: 0% 3%;\n  }\n\n  .Form {\n    padding: 0 3%;\n    border-style: groove;\n  }\n\n  .headers {\n    max-height: 35rem;\n    overflow: auto;\n    padding: 10px;\n    padding-top: 0px;\n  }\n\n  .dialog-header {\n    max-height: 35rem;\n    overflow: auto;\n  }\n\n  /* Asset Information Cards - Mobile */\n  .asset-info-container {\n    flex-direction: column !important;\n    gap: 15px !important;\n  }\n\n  .asset-info-card {\n    min-width: 100% !important;\n    width: 100% !important;\n  }\n}\n\n/* Tablet */\n@media (min-width: 768px) and (max-width: 1023px) {\n  .element {\n    width: 50%;\n    padding: 15px;\n  }\n\n  .App-content {\n    max-width: 100%;\n    padding: 0% 6%;\n  }\n\n  .Form {\n    padding: 0 6%;\n    border-style: groove;\n  }\n\n  .headers {\n    max-height: 35rem;\n    overflow: auto;\n    padding-top: 0px;\n  }\n\n  .dialog-header {\n    max-height: 35rem;\n    overflow: auto;\n  }\n\n  /* Asset Information Cards - Tablet */\n  .asset-info-container {\n    flex-direction: column !important;\n    gap: 20px !important;\n  }\n\n  .asset-info-card {\n    min-width: 100% !important;\n    width: 100% !important;\n  }\n}\n\n/* Desktop */\n@media (min-width: 1024px) {\n  .element {\n    width: 33.33%;\n    padding: 20px;\n  }\n\n  .App-content {\n    max-width: 100%;\n    padding: 0% 6%;\n  }\n\n  .Form {\n    padding: 0 6%;\n    border-style: groove;\n  }\n\n  .headers {\n    max-height: 35rem;\n    overflow: auto;\n    padding: 20px;\n    padding-top: 0px;\n  }\n\n  .dialog-header {\n    max-height: 35rem;\n    overflow: auto;\n  }\n\n  /* Asset Information Cards - Desktop */\n  .asset-info-container {\n    flex-direction: row !important;\n    gap: 20px !important;\n  }\n\n  .asset-info-card {\n    flex: 1 !important;\n    min-width: 300px !important;\n  }\n\n  /* Desktop table adjustments */\n  .mytable th,\n  .mytable td {\n    padding: 12px 8px;\n    max-width: 200px;\n  }\n}\n\n.custom-header {\n  margin-top: 25px;\n  position: fixed;\n  width: 100%;\n  background-color: #fafafa;\n  padding-left: 16px;\n  z-index: 99;\n  box-sizing: border-box;\n}\n\n.show-description {\n  position: fixed;\n  top: 95px;\n  left: 50%;\n  transform: translateX(-50%);\n  width: 90vw;\n  max-width: 700px;\n  background: #f5f5f5;\n  color: #222;\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  border-radius: 8px;\n  padding: 18px 22px;\n  z-index: 999;\n  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.08);\n  font-size: 16px;\n  font-weight: 400;\n  word-break: break-word;\n  white-space: normal;\n  overflow: hidden;\n}\n\n.cloud-permit-header {\n  max-width: calc(100% - 220px);\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
